
import { Component, Prop, Ref, Vue } from "nuxt-property-decorator";

let collapsibleIdCounter = 0;

@Component
export default class CollapsibleSection extends Vue {
  @Prop({ default: 300 }) readonly collapsedHeight!: number;
  @Prop({ required: true }) readonly expandLabel!: string;
  @Prop({ required: true }) readonly collapseLabel!: string;
  @Prop({ default: "" }) readonly ariaLabel!: string;
  @Prop({ type: Boolean, default: false })
  readonly alwaysExpandOnDesktop!: boolean;

  @Ref("contentWrapper") readonly contentWrapper!: HTMLDivElement;
  @Ref("contentInner") readonly contentInner!: HTMLDivElement;

  isExpanded = false;
  expandedHeight = 0;
  resizeObserver: ResizeObserver | null = null;
  resizeDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  instanceId = collapsibleIdCounter++;

  get wrapperId(): string {
    return `collapsible-${this.instanceId}-content`;
  }

  get wrapperStyle(): Record<string, string> {
    const maxHeight = this.resolveMaxHeight();
    return { "--collapsible-max-height": maxHeight };
  }

  resolveMaxHeight(): string {
    if (!this.isExpanded) {
      return `${this.collapsedHeight}px`;
    }
    return this.expandedHeight
      ? `${this.expandedHeight}px`
      : `${this.collapsedHeight}px`;
  }

  mounted() {
    if (!this.contentInner) return;

    this.resizeObserver = new ResizeObserver(() => {
      if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);
      this.resizeDebounceTimer = setTimeout(() => {
        if (this.isExpanded && this.contentInner) {
          this.expandedHeight = this.contentInner.scrollHeight;
        }
      }, 100);
    });

    this.resizeObserver.observe(this.contentInner);
  }

  beforeDestroy() {
    this.resizeObserver?.disconnect();
    if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);
  }

  toggle() {
    const willExpand = !this.isExpanded;
    if (willExpand && this.contentInner) {
      this.expandedHeight = 0;
      requestAnimationFrame(() => {
        if (this.contentInner) {
          this.expandedHeight = this.contentInner.scrollHeight;
        }
      });
    }
    this.isExpanded = willExpand;
  }
}
